import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreBillingAgreementsModule,
  DatastoreCurrenciesIncludingExternalModule,
  DatastorePaymentShareMembersModule,
  DatastorePaymentShareMembersSpentAmountModule,
  DatastorePaymentShareTeamsModule,
  DatastoreUsersModule,
} from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { CreateInvitationModule } from 'app/invitation/create-invitation/create-invitation.module';
import { EnterprisePaymentShareSetupCompleteComponent } from './enterprise-payment-share-setup-complete/enterprise-payment-share-setup-complete.component';
import { EnterprisePaymentShareSetupModalComponent } from './enterprise-payment-share-setup-modal.component';
import { EnterprisePaymentShareSetupSpendLimitComponent } from './enterprise-payment-share-setup-spend-limit/enterprise-payment-share-setup-spend-limit.component';
import { EnterprisePaymentShareSpendLimitInputComponent } from './enterprise-payment-share-spend-limit-input/enterprise-payment-share-spend-limit-input.component';

@NgModule({
  imports: [
    UiModule,
    TrackingModule,
    CommonModule,
    CreateInvitationModule,
    DatastoreBillingAgreementsModule,
    DatastoreCurrenciesIncludingExternalModule,
    DatastorePaymentShareTeamsModule,
    DatastorePaymentShareMembersModule,
    DatastorePaymentShareMembersSpentAmountModule,
    DatastoreUsersModule,
  ],
  declarations: [
    EnterprisePaymentShareSetupModalComponent,
    EnterprisePaymentShareSetupSpendLimitComponent,
    EnterprisePaymentShareSpendLimitInputComponent,
    EnterprisePaymentShareSetupCompleteComponent,
  ],
})
export class EnterprisePaymentShareSetupModalModule {}
